import ByCategoryContainer from 'components/ByCategory/ByCategoryContainer'
import ByCategoryPresentation from 'components/ByCategory/ByCategoryPresentation'
import ByCategoryData from 'components/ByCategory/ByCategoryData'

export default {
  Container: ByCategoryContainer,
  Presentation: ByCategoryPresentation,
  Data: ByCategoryData,
}
